import { RootState } from "@/store/store";
import { commitmentsOrganizationsSelector } from "@/store/commitments/selectors/organisations/commitmentsOrganizationsSelector";
import { ProviderType } from "@/services/cloudchipr.api";

export const commitmentsProviderOrganizationsCountsSelector = (
  state: RootState,
) => {
  const orgs = commitmentsOrganizationsSelector(state);

  return orgs?.reduce(
    (acc, org) => {
      acc[org.cloud_provider] = (acc[org.cloud_provider] || 0) + 1;

      return acc;
    },
    {} as Record<ProviderType, number>,
  );
};
